'use client';
import PropTypes from 'prop-types';
import { DeletionModal } from '@components/DeletionModal/DeletionModal';
import { EditModal } from '@components/EditModal/EditModal';
import { CameraForm } from '@components/FormComponents/CameraForm/CameraForm';
import { DeleteButton, EditButton } from '../TableActions';
import { deleteDevice } from '@utils/graphql/creators/devices';
import { cameraDeleteWarning } from '../utils/Constants';
import { MenuItem, Divider } from '@mui/material';
import { useRef } from 'react';
import '../TableActions.css';
import { handleTableActionsKeyDown } from '../utils/helpers';

export const CameraActions = ({ rowInfo, id }) => {
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);
  const buttonArray = [editButtonRef, deleteButtonRef];

  return [
    <MenuItem
      key='edit-camera-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 0);
      }}>
      <EditModal
        data={rowInfo}
        FormComponent={CameraForm}
        fieldName='camera'
        trigger={({ handleOpen }) =>
          <EditButton
            ref={editButtonRef}
            focusIdOnEscape={id}
            handleOpen={handleOpen}
            data={rowInfo}
          />
        }
      />
    </MenuItem>,
    <Divider key='divider'/>,
    <MenuItem
      key='delete-camera-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 1);
      }}>
      <DeletionModal
        customMessage={cameraDeleteWarning}
        headerIcon='fa-solid fa-video'
        data={rowInfo}
        handleDelete={deleteDevice}
        fieldName='camera'
        trigger={({ handleOpen }) =>
          <DeleteButton
            ref={deleteButtonRef}
            focusIdOnEscape={id}
            handleOpen={handleOpen}
            data={rowInfo}
          />
        }
      />
    </MenuItem>,
  ];
};

CameraActions.propTypes = {
  rowInfo: PropTypes.object,
  id: PropTypes.string,
};